import { useNavigate } from "react-router-dom";
import "./payment-failure.css";

export default function PaymentFailure() {
  const navigate = useNavigate();

  const handleRetryPayment = () => {
    navigate("/dashboard");
  };

  const handleContactSupport = () => {
    window.location.href = "tel:+918045681681";
  };

  const handleTryDifferentMethod = () => {
    navigate("/dashboard");
  };

  return (
    <div className="payment-failure-status-container">
      <div className="payment-failure-status-card payment-failure-failed">
        <div className="payment-failure-failed-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#dc3545" strokeWidth="2" />
            <line x1="15" y1="9" x2="9" y2="15" stroke="#dc3545" strokeWidth="2" />
            <line x1="9" y1="9" x2="15" y2="15" stroke="#dc3545" strokeWidth="2" />
          </svg>
        </div>

        <h1>Payment Failed</h1>
        <p className="payment-failure-error-message">
          Your payment could not be processed. Please try again with a different payment method.
        </p>

        <div className="payment-failure-failure-help-section">
          <h3>Common Solutions:</h3>
          <ul>
            <li>✓ Check your internet connection</li>
            <li>✓ Ensure sufficient balance in your account</li>
            <li>✓ Verify your card details are correct</li>
            <li>✓ Try using a different payment method</li>
            <li>✓ Contact your bank if payment is being declined</li>
          </ul>
        </div>

        <div className="payment-failure-action-buttons">
          <button className="payment-failure-primary-btn" onClick={handleRetryPayment}>
            Try Again
          </button>
          <button className="payment-failure-secondary-btn" onClick={handleTryDifferentMethod}>
            Try Different Method
          </button>
        </div>

        <div className="payment-failure-alternative-section">
          <h3>Alternative Payment Options:</h3>
          <div className="payment-failure-payment-methods">
            <div className="payment-failure-payment-method">
              <img src="/google-icon.svg" alt="Google Pay" width="24" height="24" />
              <span>Google Pay / PhonePe</span>
            </div>
            <div className="payment-failure-payment-method">
              <span>💳</span>
              <span>Debit/Credit Card</span>
            </div>
            <div className="payment-failure-payment-method">
              <span>🏦</span>
              <span>Net Banking</span>
            </div>
            <div className="payment-failure-payment-method">
              <span>📱</span>
              <span>UPI</span>
            </div>
          </div>
        </div>

        <div className="payment-failure-support-section">
          <h3>Need Help?</h3>
          <p>Our support team is here to assist you</p>

          <div className="payment-failure-contact-options">
            <button className="payment-failure-contact-btn" onClick={handleContactSupport}>
              📞 Call Support
            </button>
            <button
              className="payment-failure-contact-btn"
              onClick={() => (window.location.href = "mailto:support@homeshiksha.com")}>
              ✉️ Email Support
            </button>
            <button
              className="payment-failure-contact-btn"
              onClick={() => window.open("https://wa.me/918045681681", "_blank")}>
              💬 WhatsApp
            </button>
          </div>

          <div className="payment-failure-contact-info">
            <p>
              <strong>Phone:</strong> +91 80456 81681
            </p>
            <p>
              <strong>Email:</strong> support@homeshiksha.com
            </p>
            <p>
              <strong>Hours:</strong> 9:00 AM - 8:00 PM (Mon-Sat)
            </p>
          </div>
        </div>

        <div className="payment-failure-reassurance-section">
          <h4>Don't worry!</h4>
          <p>
            If any amount was deducted from your account, it will be automatically refunded within 5-7 working days. You
            can also continue using our services without payment - we'll arrange tutors based on availability.
          </p>
        </div>
      </div>
    </div>
  );
}
